<template>
  <div>
    <v-menu v-if="isAuthenticated" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-if="isAuthenticated && user && user.name"
          ref="btnMenu" 
          class="app-bar__button" fab
          v-bind="attrs"
          v-on="on"
        >
        {{ userNameInitials }}
        </v-btn>
        <v-btn v-else
          class="app-bar__button" fab
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in user_profile_menu"
          :key="index"
          @click="item.action()"
        >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    
    <v-btn v-else
      class="button__primary"
      to="/user/login"
      >
      {{ $t('app.appbar.login') }}
    </v-btn>
  </div>
</template>

<script>
import store from '@/store/index'
import router from '@/router/index'
import { mapState } from "vuex";

export default {
  data() {
    return {
      user_profile_menu: [
        { 
          title: this.$i18n.t('userProfile.headline'),
          action: function() {
            if(router) {
              router.push('/user/profile')
            }
          }, 
        },
        { 
          title: this.$i18n.t('app.appbar.logout'),
          action: function() {
            store.dispatch('logout');
          }, 
        },
      ],
    }
  },
  computed: {
    ...mapState(['isAuthenticated', 'user']),
    userNameInitials: {
      get() {
        if (this.user && this.user.name) {
          var names = this.user.name.split(' '),
          initials = names[0].substring(0, 1).toUpperCase();
    
        if (names.length > 1) {
          initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        }
        return initials ? initials: '';
      },
    },
  },
  mounted: function ()  {
    this.user_profile_menu.forEach((m) => (m.comp = this));
  },
}
</script>
